import { Link } from "react-router-dom"

export default function ComingSoon() {
    return (
        <dialog
            id="signUpDetails"
            className="ps-4 pe-4"
            style={{ width: "50%" }}
        >
            <img
                src={`/image/world-map-red-pins-greyscale.png`}
                className="card-img-top"
                alt="World Map"
            />
            <h5 className="card-title pt-3 pb-2">Coming Soon</h5>

            <p className="card-text text-start pt-3">
                We are excited to announce that we are working on some epic
                developments to our platform that will enhance your travel
                experience and keep you in the know about the safety of the
                people and places you care about.<br></br>
                <br></br>
                Please stay tuned for our upcoming features and sign up so that
                we can take things to the next level as we provide you with
                real-time safety data, insights, and alerts so that you can
                protect your focus and preserve your peace of mind.
                <br></br>
                <br></br>
                In the meantime, please feel free to explore our platform and if
                you would like to join our waitlist for early access to these
                exciting new features, please{" "}
                <Link to="/contact">contact us</Link> and let us know.
            </p>
            <hr className="mt-4 mb-4"></hr>
            <button
                className="btn btn-outline-secondary"
                autoFocus
                onClick={() => {
                    const signUpDialog =
                        document.getElementById("signUpDetails")
                    signUpDialog.close()
                }}
            >
                Close
            </button>
        </dialog>
    )
}
